import React from "react";
// @ts-expect-error cant be bothered adding a declaration
import { DefaultTooltipContent } from "recharts/lib/component/DefaultTooltipContent";
import { NameType } from "recharts/types/component/DefaultTooltipContent";
import { ContentType } from "recharts/types/component/Tooltip";

const createCustomTooltip = (ordering: "highest" | "lowest") => {
  const CustomTooltip: ContentType<any, NameType> = (props: any) => {
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!props.active) {
      // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
      return null;
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    const newPayload = [
      ...props.payload.sort((a: any, b: any) => {
        if (ordering === "highest") {
          return b.value - a.value;
        } else {
          return a.value - b.value;
        }
      }),
    ];

    // we render the default, but with our overridden payload
    return (
      <div style={{ fontSize: "clamp(0.5rem, 0.9vw, 2rem)" }}>
        {" "}
        <DefaultTooltipContent {...props} payload={newPayload} />
      </div>
    );
  };
  return CustomTooltip;
};

export default createCustomTooltip;
